import { gate } from 'hub-http/gates';
export const DEAL_STAGE_FORECASTING = 'Sales:Forecast:DealStageForecasting';
export const MULTI_PIPELINE = 'Sales:Forecast:Multipipeline';
export const AI_PROJECTIONS = 'Forecasting:AIProjections';
export const AI_FORECAST_VISUALIZATION = gate('Forecasting:AIForecastVisualization');
export const MULTIPLE_OUTCOMES = 'Forecasting:MultipleOutcomes';
export const MANUAL_SUBMISSION_OVERHAUL = gate('Forecasting:ManualSubmissionOverhaul');
export const GOALS_BUG_ALERT = gate('Forecasting:GoalsBugAlert');